export enum RequestType {
  All = '0',
  NCKH = '1',
  TDBA = '2',
  TTBA = '3',
  CNND = '4',
  TCBA = '5',
  SUM_MEDICAL = '6',
  NEW_MEDICAL = '7',
  INVENTORY_MEDICAL = '8',
  EXPIRED_MEDICAL = '9'
}
